export * from './IPage';
export * from './ITranslation';
export * from './IConfiguration';
export * from './IDocument';